import * as React from 'react';
import { compose, setDisplayName, withHandlers } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { connect } from 'react-redux';
import { State } from 'reducers';
import { modal } from 'ui/shared/modal';
import { getAppVersion, getDevicePackVersion, getCopyrightYear } from 'selectors/serverSelectors';
import { Button } from 'ui/shared/Button';

import './AboutDialog.css';

const titleSrc = require('assets/images/oem/TitleLarge.png');

export type OwnProps = {
    visible: boolean;
    onClose: () => void;
};

type StateProps = {
    appVersion: string;
    devicePackVersion: string;
    copyrightYear: number;
};

type RecomposeProps = {
    handleKeyDown: React.KeyboardEventHandler<HTMLDivElement>;
};

const buttonStyle: React.CSSProperties = {
    float: 'right',
};

const RawAboutDialog = ({ onClose, appVersion, devicePackVersion, copyrightYear, handleKeyDown, t }: StateProps & OwnProps & RecomposeProps & TranslateProps) =>
    <div
        onKeyDownCapture={ handleKeyDown }
    >
        <header>
            <img src={ titleSrc }/>
        </header>

        <p>
            <label>{ t('79') }</label>
            <span className="version">{ appVersion }</span>
        </p>
        <p>
            <label>{ t('About_DevicePackVersionLabel') }</label>
            <span className="version">{ devicePackVersion }</span>
        </p>
        <p className="copyright">{ t('OEM_CopyrightWebClient', [copyrightYear]).replace(/\\n/g, ' ') }</p>

        <Button
            id="about-dialog-close-button"
            onClick={ onClose }
            style={ buttonStyle }
            textKey="289"
            autoFocus={ true }
        />
    </div>
;

const mapStateToProps = (state: State) => ({
    appVersion: getAppVersion(state),
    devicePackVersion: getDevicePackVersion(state),
    copyrightYear: getCopyrightYear(state),
});

export const AboutDialog = compose<StateProps & OwnProps & RecomposeProps & TranslateProps, OwnProps>(
    setDisplayName('AboutDialog'),
    translate(),
    connect<StateProps, {}, OwnProps>(mapStateToProps),
    withHandlers({
        handleKeyDown: ({ visible, onClose }: OwnProps) => (e: React.KeyboardEvent<HTMLDivElement>) => {
            if (visible && e.key === 'Escape') {
                onClose();
            }
        },
    }),
    modal('about-dialog'),
)(RawAboutDialog);



// WEBPACK FOOTER //
// ./src/ui/main/header/AboutDialog.tsx